import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M14.24 12l.4 2H18V8h-5.24l-.4-2H7v6z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 14h5.6l.4 2h7V6h-5.6L14 4H5v17h2v-7zm0-8h5.36l.4 2H18v6h-3.36l-.4-2H7V6z"
})), 'AssistantPhotoTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AssistantPhotoTwoTone.js
// module id = 2179
// module chunks = 2